<template>
	<router-link 
		class="partner-card-wrapper px-4 py-4 mb-4"
		:to="{
			name: 'exhibitor-by-id',
			params: {
				id: partner.partner_id
			}
		}"
		@click.native="handleClick"
	>
		<img 
			:src="partner.partner_logo"
			alt="partnerLogo"
			class="partner-card-logo"
			loading="lazy"
		/>
		<div>
			<div class="partner-card-title">
				{{ partner.partner_name }}
			</div>
			<div class="partner-card-description">
				{{ partner.partner_brief_description }}
			</div>
		</div>
	</router-link>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import Dwh from '@/mixins/Dwh'

Vue.use(VueScrollTo)

export default {
	name: 'PartnerCard',
	mixins: [Dwh],
	props: {
		partner: {
			type: Object,
			default: () => {},
		},
	},
	methods: {
		handleClick() {
			this.sendTrigger({
				category: 'Content',
				action: 'click_exhibitor_profile_event',
				module: 'Events',
				data: this.partner.partner_id,
				title: this.partner.partner_name
			})
		}
	}
}
</script>

<style lang="scss">
.partner-card {
	&-wrapper {
		display: flex;
		background: rgb(251, 251, 251);
		border: 1px solid rgb(226, 226, 226);
		border-radius: 12px;
		text-decoration: none;
	}

	&-logo {
		width: 25%;
		object-fit: contain;
		margin-right: 10px;
	}
	&-title {
		color: var(--username-category-title);
		font-size: 14px;
		font-family: Montserrat;
		font-weight: bold;
	}

	&-description {
		color: rgb(74, 74, 74);
		font-size: 14px;
		font-family: Montserrat;
		font-weight: normal;
		line-height: 20px;
	}
}
</style>
